import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EpaycoPage } from './epayco.page';

const routes: Routes = [
  {
    path: '',
    component: EpaycoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EpaycoPageRoutingModule {}
